module.exports = __webpack_public_path__ + "static/media/product5.89afcae2.jpg";